import React from 'react';
import SalesLayout from '../../../components/SalesLayout.jsx';
import DealForm from '../../Superadmin/Deals/_Form.jsx';

// Reuses the superadmin deal form so a rep-authored deal is built from exactly
// the same fields and posted to the same server-side authoring path.
export default function SalesDealsNew({
  deal, available_items = [], available_facility_types = [], available_plans = [], errors = [],
  facility_search_path = null,
}) {
  return (
    <SalesLayout>
      <div className="max-w-2xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">New deal</h1>
          <p className="mt-1 text-sm text-gray-500">
            You'll get a shareable link once it's saved. Deals can't be edited afterwards — the link may
            already be with a customer, so changing the terms would move the goalposts underneath them.
          </p>
        </div>

        <DealForm
          deal={deal}
          availableItems={available_items}
          availableFacilityTypes={available_facility_types}
          availablePlans={available_plans}
          errors={errors}
          facilitySearchPath={facility_search_path}
          submitPath="/sales/deals"
          cancelPath="/sales"
        />
      </div>
    </SalesLayout>
  );
}
